<template>
  <div>
    <slot name="txtBefore"></slot>
    <AGBChecked
      :consentAGBProp.sync="consentAGBProp"
      :consentInformationArticleProp.sync="consentInformationArticleProp"
    >
      <template v-for="slot in possibleChildSlotsFor('AGBChecked')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </AGBChecked>
    <div class="solvency-check-terms-data">
      <slot name="solvencyCheckTermsDataContentHeadline">Schufa</slot>
      <div class="SolvencyCheckTermsDataContent" v-html="solvencycheckTerms"></div>
    </div>
    <ContractSummaryDocument>
      <template v-for="slot in possibleChildSlotsFor('ContractSummaryDocument')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ContractSummaryDocument>
    <ConsultationConsent :consents="brandConsents.consents"
                         :selectedInfoExchangeConsentProp.sync="selectedInfoExchangeConsentProp"
                         :selectedContactConsentProp.sync="selectedContactConsentProp"
    >
      <template v-for="slot in possibleChildSlotsFor('ConsultationConsent')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsultationConsent>
      <div class="indication-contract-data">
        <slot name="indicationContractDataHeadline"></slot>
        <slot name="indicationContractDataContent"></slot>
      </div>
  </div>
</template>
<script>
import AGBChecked from '@/components/process/FYVE/Order/Consent/AGBChecked.vue'
import ConsultationConsent from '@/components/process/FYVE/Order/Consent/ConsultationConsent.vue'
import ContractSummaryDocument from '@/components/process/FYVE/Order/Consent/ContractSummaryDocument.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import syncProperty from '@/mixins/syncProperty'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'ConsentData',
  data: function () {
    return {
      brandConsents: {
        consents: [
        ]
      },
      filterKeys: ['data_handling_terms', 'bew_checkout_terms', 'solvencycheck_terms']
    }
  },
  computed: {
    solvencycheckTerms: function () {
      return this.brandConsents.consents.find(item => item.name === 'solvencycheck_terms')?.text || ''
    },
    termsVersion: function () {
      return this.brandConsents.contractTermsVersion
    }
  },
  components: {
    AGBChecked,
    ConsultationConsent,
    ContractSummaryDocument
  },
  apollo: {
    brandConsents: function () {
      const me = this
      return wrapQuery(gql`query order ($brand: String!, $filterKeys: [String!]) {
        brandConsents(brand:$brand, filterKeys: $filterKeys) {
          consents {
            name
            text
            version
          }
          contractTermsVersion
        }
      }`, this, 'brandConsents', {
        brand: this.$store.getters.brand,
        filterKeys: this.filterKeys
      },
      function (data) {
        me.contractTermsVersionProp = data.contractTermsVersion
      })
    }
  },
  mixins: [
    syncProperty('contractTermsVersion', 'contractTermsVersionProp'),
    syncProperty('consentAGB', 'consentAGBProp'),
    syncProperty('consentInformationArticle', 'consentInformationArticleProp'),
    syncProperty('selectedInfoExchangeConsent', 'selectedInfoExchangeConsentProp'),
    syncProperty('selectedContactConsent', 'selectedContactConsentProp'),
    slotProxy()
  ]
}
</script>
